import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Actividades", href: "#actividades" },
  { label: "Horarios", href: "#horarios" },
  { label: "Precios", href: "#precios" },
  { label: "FAQs", href: "#faqs" },
  { label: "Inscripción", href: "#inscripcion" },
];

export default function Navbar({ general }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-xl shadow-md py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3">
          {general.logo_url ? (
            <img
              src={general.logo_url}
              alt="Logo"
              className="h-12 w-12 object-contain rounded-full bg-white p-0.5"
            />
          ) : null}
          <div className={`font-['Montserrat'] font-bold leading-tight transition-colors ${scrolled ? "text-[#0072A4]" : "text-white"}`}>
            <div className="text-base sm:text-lg">Campus Verano</div>
            <div className="text-xs sm:text-sm font-medium opacity-80">La Estanca 2026</div>
          </div>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`font-['Montserrat'] font-700 text-sm transition-colors hover:text-[#F5C518] ${
                scrolled ? "text-[#0F172A]" : "text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#inscripcion"
            data-testid="nav-register-btn"
            className="bg-[#F5C518] text-[#0F172A] font-['Montserrat'] font-bold px-5 py-2 rounded-full text-sm hover:bg-[#D4A914] transition-all active:scale-95 shadow-md"
          >
            ¡Inscríbete!
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className={`md:hidden p-2 rounded-lg transition-colors ${scrolled ? "text-[#0072A4]" : "text-white"}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-toggle"
          aria-label="Menú"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu — full screen overlay */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-0 bg-white z-40 flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-[#F1F5F9]">
            <a href="#" className="flex items-center gap-3" onClick={() => setMobileOpen(false)}>
              {general.logo_url ? (
                <img src={general.logo_url} alt="Logo" className="h-10 w-10 object-contain rounded-full bg-white" />
              ) : null}
              <div className="font-['Montserrat'] font-bold text-[#0072A4] text-base leading-tight">
                <div>Campus Verano</div>
                <div className="text-xs font-medium text-[#475569]">La Estanca 2026</div>
              </div>
            </a>
            <button
              onClick={() => setMobileOpen(false)}
              className="p-2 rounded-xl text-[#0F172A] hover:bg-[#F1F5F9] transition-colors"
              aria-label="Cerrar menú"
            >
              <X size={24} />
            </button>
          </div>
          {/* Links */}
          <nav className="flex flex-col flex-1 justify-center px-8 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-['Montserrat'] font-bold text-2xl text-[#0F172A] py-4 border-b border-[#F1F5F9] hover:text-[#0072A4] transition-colors"
                onClick={() => setMobileOpen(false)}
                data-testid={`mobile-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>
          {/* CTA */}
          <div className="px-8 pb-12">
            <a
              href="#inscripcion"
              data-testid="mobile-register-btn"
              className="block w-full bg-[#F5C518] text-[#0F172A] font-['Montserrat'] font-bold py-4 rounded-full text-center text-lg hover:bg-[#D4A914] transition-all active:scale-95 shadow-lg"
              onClick={() => setMobileOpen(false)}
            >
              ¡Inscríbete Ahora!
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
